import { Trans } from "turboui";
import { useTranslation } from "react-i18next";
import * as Pages from "@/components/Pages";
import * as Paper from "@/components/PaperContainer";
import * as Goals from "@/models/goals";
import * as React from "react";

import { Form as CheckInForm, useForm } from "@/features/goals/GoalCheckIn";
import { banner } from "@/features/goals/GoalPageHeader/Banner";
import { useSubscriptionsAdapter } from "@/models/subscriptions";
import { PageModule } from "@/routes/types";

import { FormattedTime } from "turboui";
import { useFormattedTimePreferences } from "@/hooks/useFormattedTimePreferences";

import { loader, useLoadedData } from "./loader";
import { Navigation } from "./navigation";
export default { name: "GoalCheckInNewPage", loader, Page } as PageModule;

function Page() {
  const { t } = useTranslation();
  const { goal } = useLoadedData();

  return (
    <Pages.Page title={[t("Check-in"), goal.name]} testId="goal-check-in-new-page">
      <Paper.Root>
        <Navigation />

        <Paper.Body className="p-4 md:p-8 lg:px-28 lg:py-8" noPadding banner={banner(goal)}>
          <Header />
          <Form goal={goal} />
        </Paper.Body>
      </Paper.Root>
    </Pages.Page>
  );
}

function Header() {
  const { t } = useTranslation();
  const formattedTimePreferences = useFormattedTimePreferences();

  return (
    <div>
      <h1 className="text-content-accent text-xl sm:text-3xl font-extrabold text-center">
        <Trans
          i18nKey="Check-In for <date/>"
          components={{ date: <FormattedTime {...formattedTimePreferences} time={new Date()} format="long-date" /> }}
        />
      </h1>
      <p className="text-center mt-1">{t("Share the progress with the team")}</p>
    </div>
  );
}

function Form({ goal }: { goal: Goals.Goal }) {
  const opts = goal.space ? { spaceName: goal.space.name } : { goalName: goal.name };
  const subscriptionsState = useSubscriptionsAdapter(goal.potentialSubscribers || [], {
    ignoreMe: true,
    notifyPrioritySubscribers: true,
    ...opts,
  });

  const form = useForm({ mode: "new", goal, subscriptionsState });

  return (
    <CheckInForm
      taskList={{ canEdit: false }}
      form={form}
      goal={goal}
      mode="new"
      allowFullEdit
      subscriptionsState={subscriptionsState}
    />
  );
}
